/** Retire only the existing £5 offers; leave Klaviyo and other dialogs intact. */
const offerIds = ['Ypnyuy', 'Vz2ADV', 'YhQaPY'];
const offerSelector = offerIds
  .flatMap((id) => [`[data-testid="klaviyo-form-${id}"]`, `.kl-teaser-${id}`])
  .join(',');
const dismissed = new WeakSet();

function dismissOffer(offer) {
  const container = offer.closest('[role="dialog"]') ?? offer;
  const closeButton = container.querySelector('button.klaviyo-close-form');

  if (!closeButton || dismissed.has(container)) return;

  dismissed.add(container);
  // Keep the close animation running invisibly: Klaviyo releases its scroll
  // lock on animationend, which display:none would prevent.
  container.style.setProperty('visibility', 'hidden', 'important');
  container.style.setProperty('opacity', '0', 'important');
  container.style.setProperty('pointer-events', 'none', 'important');
  closeButton.click();
}

function inspectAddedElement(element) {
  if (!(element instanceof Element)) return;

  if (element.matches(offerSelector)) dismissOffer(element);
  for (const offer of element.querySelectorAll(offerSelector)) dismissOffer(offer);

  // Klaviyo can attach the close button after mounting the form or teaser.
  const container = element.closest('[role="dialog"], [class*="kl-teaser-"]');
  if (!container) return;
  if (container.matches(offerSelector)) dismissOffer(container);
  for (const offer of container.querySelectorAll(offerSelector)) dismissOffer(offer);
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) inspectAddedElement(node);
  }
});

// Forms can arrive after consent, on a timer, or when the visitor leaves a page.
// This module runs once per document; navigation disposes its observer.
observer.observe(document.body, { childList: true, subtree: true });
inspectAddedElement(document.body);
